import {
  changeActive,
  changeAgenda,
  changeApprove,
  changeEmail,
  givePremium,
  removePremium,
  changeCRPPhotos,
} from "@/views/Users/UserDetail/userFunctions";
import { Modal } from "bootstrap";
import { email, required } from "vuelidate/lib/validators";
import {
  PsiDetailAppointments,
  PsiDetailBankInfo,
  PsiDetailCoupons,
  PsiDetailPayouts,
  PsiDetailProfile,
  PsiDetailRatings,
  PsiDetailRegisterInfo,
  PsiDetailSchedules,
  PsiDetailSummary,
  PsiDetailSubscriptions,
  PsiDetailConnectAccounts,
} from "./PsiDetailComponents";
import UserChangeLogsTab from "@/components/UserChangeLogsTab.vue";

export default {
  mounted() {
    this.changeEmailModal = new Modal(
      document.getElementById("changeEmailModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.changeCRPPhotosModal = new Modal(
      document.getElementById("changeCRPPhotosModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      isApproving: false,
      showSummary: true,
      changeEmailModal: null,
      changeCRPPhotosModal: null,
      item: {},
      id: this.$route.params.id,
      loadingItems: false,
      submitting: false,
      errorMessage: "",
      changeLogsLoaded: false,
      connectAccountsLoaded: false,
      appointmentsLoaded: false,
      subscriptionsChargesLoaded: false,
      form: {
        email: "",
      },
      changeCRPPhotosForm: {
        document_image: null,
        document_in_hand: null,
      },
      documentImagePreview: null,
      documentInHandPreview: null,
    };
  },
  components: {
    PsiDetailRegisterInfo,
    PsiDetailProfile,
    PsiDetailSchedules,
    PsiDetailBankInfo,
    PsiDetailAppointments,
    PsiDetailPayouts,
    PsiDetailRatings,
    PsiDetailCoupons,
    PsiDetailSummary,
    PsiDetailSubscriptions,
    PsiDetailConnectAccounts,
    UserChangeLogsTab,
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
    changeCRPPhotosForm: {
      document_image: {
        required,
      },
      document_in_hand: {
        required,
      },
    },
  },
  methods: {
    cropEndDocumentImage(image) {
      this.$set(this.changeCRPPhotosForm, "document_image", image);
    },
    cropEndDocumentInHand(image) {
      this.$set(this.changeCRPPhotosForm, "document_in_hand", image);
    },
    handleDocumentImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.changeCRPPhotosForm, "document_image", { file });
      this.$set(this, "documentImagePreview", {
        url: URL.createObjectURL(file),
        isPdf: file.type === "application/pdf",
      });
    },
    handleDocumentInHandChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.changeCRPPhotosForm, "document_in_hand", { file });
      this.$set(this, "documentInHandPreview", {
        url: URL.createObjectURL(file),
        isPdf: file.type === "application/pdf",
      });
    },
    resetCRPPhotosForm() {
      this.changeCRPPhotosForm = { document_image: null, document_in_hand: null };
      this.documentImagePreview = null;
      this.documentInHandPreview = null;
    },
    async getData() {
      try {
        const res = await this.$userService.show(this.id);
        let data = this.$userService.preparePsi(res.data);
        const couponsRes = await this.$couponsService.list({
          psychologist_id: this.id,
        });
        data.coupons = couponsRes.data.map((r) =>
          this.$couponsService.prepareCoupon(r)
        );
        this.$set(this, "item", data);
        this.$set(this.form, "email", data.email);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    changeEmailClicked() {
      this.changeEmailModal.toggle();
    },
    changeCRPPhotosClicked() {
      this.resetCRPPhotosForm();
      this.changeCRPPhotosModal.toggle();
    },
    handleChangeEmail() {
      this.submitting = true;
      changeEmail({ id: this.item.id, email: this.form.email }, () => {
        this.$eventBus.$emit("showToast", {
          title: "Email alterado",
          msg: `O email foi alterado com sucesso`,
        });
        this.changeEmailModal.toggle();
        this.getData();
        this.submitting = false;
      });
    },
    handlechangeCRPPhotos() {
      this.submitting = true;
      this.errorMessage = "";
      const values = { ...this.changeCRPPhotosForm };
      if (values.document_image) {
        values.document_image = values.document_image.file;
      }
      if (values.document_in_hand) {
        values.document_in_hand = values.document_in_hand.file;
      }
      console.log(values);

      changeCRPPhotos(
        {
          id: this.item.id,
          document_image: values.document_image,
          document_in_hand: values.document_in_hand,
        },
        () => {
          this.$eventBus.$emit("showToast", {
            title: "fotos do CRP alteradas",
            msg: `Fotos do CRP alteradas com sucesso`,
          });
          this.changeCRPPhotosModal.toggle();
          this.getData();
          this.submitting = false;
        }
      );
    },
    handleChangeActive() {
      changeActive(this.item, () => this.getData());
    },
    async handleChangeApprove() {
      this.isApproving = true;
      changeApprove(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: !this.item.approved
            ? "Usuário aprovado"
            : "Usuário Desaprovado",
          msg: !this.item.approved
            ? `O Usuário foi aprovado com sucesso`
            : `O Usuário foi desaprovado`,
        });
        this.getData();
        this.isApproving = false;
      });
    },
    handleGivePremium() {
      givePremium(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: "Psi promovido para premium",
          msg: `O Psi é agora é um assinante`,
        });
        this.getData();
      });
    },
    handleRemovePremium() {
      removePremium(this.item, () => {
        this.$eventBus.$emit("showToast", {
          title: "Premium removido do psi",
          msg: `O Psi é agora é um usuário free`,
        });
        this.getData();
      });
    },
    handleChangeAgenda() {
      changeAgenda(this.item, () => {
        this.getData();
      });
    },
    handleCouponDetail(id) {
      this.$router.push({ path: `${this.$paths.coupons.detail}/${id}` });
    },
    async changeCallProvider(value) {
      try {
        let params = { call_provider: value };
        await this.$userService.update(this.item?.id, params);
        this.getData();
      } catch (error) {
        console.log(error);
      }
    },
    loadChangeLogsTab() {
      if (!this.changeLogsLoaded) {
        this.changeLogsLoaded = true;
      }
    },
    loadAppointmentsTab() {
      if (!this.appointmentsLoaded) {
        this.appointmentsLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.appointmentsComponent) {
            this.$refs.appointmentsComponent.loadAppointments();
          }
        });
      }
    },
    loadConnectAccountsTab() {
      if (!this.connectAccountsLoaded) {
        this.connectAccountsLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.connectAccountsComponent) {
            this.$refs.connectAccountsComponent.loadConnectAccounts();
          }
        });
      }
    },
    loadSubscriptionsTab() {
      if (!this.subscriptionsChargesLoaded) {
        this.subscriptionsChargesLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.subscriptionsComponent) {
            this.$refs.subscriptionsComponent.loadChargesForIncompleteInvoices();
          }
        });
      }
    },
  },
};
